export default __webpack_public_path__ + "static/media/ramsey.d5784fdf.jpg";